import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd, { SITE_URL, SITE_NAME, SITE_LOGO } from '@/components/feature/JsonLd';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import ResourcesSection from './components/ResourcesSection';
import FeaturedSections from './components/FeaturedSections';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: 'USFans Spreadsheet complete guide covering product research, sellers, QC, shipping, warehouse processes and safety tips. Independent resources organized in one hub.',
    inLanguage: ['en', 'pl', 'es', 'fr'],
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: { '@type': 'ImageObject', url: SITE_LOGO },
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: { '@type': 'ImageObject', url: SITE_LOGO },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <InfoSections />
        <ResourcesSection />
        <FeaturedSections />
        <ArticleSection />
      </main>
      <Footer />
    </div>
  );
}